import { render } from "./SliderCarousel.vue?vue&type=template&id=4e1cc47e&scoped=true"
import script from "./SliderCarousel.vue?vue&type=script&lang=js"
export * from "./SliderCarousel.vue?vue&type=script&lang=js"

import "./SliderCarousel.vue?vue&type=style&index=0&id=4e1cc47e&scoped=true&lang=css"

import exportComponent from "E:\\1402\\Back\\API_Core\\ApiCore\\clientapp\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4e1cc47e"]])

export default __exports__